export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f58791e366843445f1b57762035eabdf71ad1874a&name=fetchTypeahead!'